import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Container from "../components/container";
import styled from "@emotion/styled"
import faker from "faker";

const Styles = styled.div`
  padding: 84px 0px;
  min-height: 100vh;

  .my-courses {
    display: grid;
    grid-gap: 36px;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))
  }

  .gatsby-image-wrapper {
    border-bottom: 1px solid #ccc;
    height: 165px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .subtitle {
    margin-bottom: 8px;
  }

  .card {
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .card-content {
    padding: 14px;
  }

  
`

export default class extends React.Component {
  constructor () {
    super();
    this.state = {}
  }

  render () {
    let courses = [
      
      {
        title: "Gatsby Tutorial & Projects Course",
        url: "https://www.udemy.com/course/gatsby-tutorial-and-projects-course?ref=gatsby-university",
        author: "John Smilga",
        distributor: {
          name: "Udemy",
          url: "https://udemy.com?ref=gatsby-university",
        },
        image: this.props.data.gatsbyTutorial.childImageSharp.fluid,
        priceForAccess: "$19.99",
      }, 

      {
        title: "Build Content Rich Progressive Web Apps with Gatsby and Contentful",
        url: "https://egghead.io/courses/build-content-rich-progressive-web-apps-with-gatsby-and-contentful?ref=gatsby-university",
        author: "Khaled Garbaya",
        distributor: {
          name: "Egghead.io",
          url: "https://egghead.io?ref=gatsby-university",
        },
        image: this.props.data.buildContent.childImageSharp.fluid,
        priceForAccess: "$29",
      }, 

    
      
      {
        title: "Introduction to Gatsby",
        url: "https://frontendmasters.com/courses/gatsby?ref=gatsby-university",
        author: "Jason Lengstorf",
        image: this.props.data.frontendMasters.childImageSharp.fluid,
        priceForAccess: "$40/mo",
        distributor: {
          name: "FrontEndMasters",
          url: "https://frontendmasters.com?ref=gatsby-university",
        },
      }, 

      {
        title: "Advanced Gatsby & Shopify",
        url: "https://www.leveluptutorials.com/tutorials/advanced-gatsby-and-shopify?ref=gatsby-university",
        author: "Scott Tolinski",
        image: this.props.data.advancedGatsbyShopify.childImageSharp.fluid,
        priceForAccess: "$39.99 or $24.99/mo",
        distributor: {
          name: "LevelUp Tutorials",
          url: "https://www.leveluptutorials.com?ref=gatsby-university",
        },
      }, 

      {
        title: "Gatsby Ecommerce",
        url: "https://www.leveluptutorials.com/tutorials/gatsby-ecommerce?ref=gatsby-university",
        author: "Scott Tolinski",
        image: this.props.data.gatsbyEcommerce.childImageSharp.fluid,
        priceForAccess: "$49.99 or $24.99/mo",
        distributor: {
          name: "LevelUp Tutorials",
          url: "https://www.leveluptutorials.com?ref=gatsby-university",
        },
      }, 

      {
        title: "GatsbyJS: Getting Started",
        url: "https://www.pluralsight.com/courses/gatsbyjs-getting-started?ref=gatsby-univeristy",
        author: "Marcelo Pastorino",
        image: this.props.data.gettingStarted.childImageSharp.fluid,
        priceForAccess: "$29.99/mo",
        distributor: {
          name: "Pluralsight",
          url: "https://www.pluralsight.com?ref=gatsby-univeristy",
        },
      }, 

      

      
      
    ]

    return (
      <Layout path="courses">
        <SEO title="Courses" />
          <Styles>
        <Container>
              <div className="title">
                Courses
              </div>

              <div className="my-courses">
                {
                  courses.map( (el) => {
                    return (
                      <a href={ el.url } target="_blank" rel="noopener noreferrer" key={ el.url }>
                        <div className="card">
                          <div className="card-image" >
                            <Img className="my-image" fluid={ el.image } alt={ el.title } />


                          </div>
                          <div className="card-content">
                            <div className="title is-6">
                            {
                              el.title
                            }
                            </div>

                            <div className="subtitle is-6" style={{marginBottom: 0}}>
                              {
                                el.author
                              }
                            </div>

                            <div>
                              <small>
                              <a href={el.distributor.url} target="_blank" rel="noopener noreferrer">@{ el.distributor.name}</a>
                              </small>
                            </div>

                            <div className="my-price" >
                              { el.priceForAccess }
                            </div>

                            
                            
                          </div>
                          
                          
                        
                        </div>

                      </a>
                    )
                  })
                }

              </div>
        </Container>
          </Styles>
      </Layout>
    )
  }
}

export const query = graphql`
  {
    frontendMasters: file(relativePath: { eq: "frontend-masters-gatsby.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    advancedGatsbyShopify: file(relativePath: { eq: "advanced-gatsby-shopify.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    gatsbyEcommerce: file(relativePath: { eq: "gatsby-ecommerce.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    gettingStarted: file(relativePath: { eq: "getting-started.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    gatsbyTutorial: file(relativePath: { eq: "gatsby-tutorial.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    buildContent: file(relativePath: { eq: "build-content.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    

    

    

    
  }

`

